import { createFileRoute } from '@tanstack/react-router';
import { RequireService } from '@/components/shared/require-service';
import { PendingTransactionsPage as PendingTransactionsPageContent } from '@/features/pending-transactions/pending-transactions-page';

function PendingTransactionsPage() {
  return (
    <RequireService service="PENDING_TRANSACTION_LIST">
      <PendingTransactionsPageContent />
    </RequireService>
  );
}

export const Route = createFileRoute('/_app/pending-transactions')({
  component: PendingTransactionsPage,
});
